import { createFileRoute } from '@tanstack/react-router'

import { TechnicalError } from '@orus.eu/error'

import { PartnersClaimPage } from '../../../../components/pages/backoffice/partners/partners-claim-page.tsx'
import { PlatformClaimPage } from '../../../../components/pages/backoffice/platform/platform-claim-page/platform-claim-page.tsx'
import { useBackofficeUser } from '../../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/claims/$claimId/')({
  component: function Component() {
    const { claimId } = Route.useParams()
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      throw new TechnicalError('There should have been a backoffice user at this point')
    }

    return backofficeUser.type === 'platform' ? <PlatformClaimPage /> : <PartnersClaimPage claimId={claimId} />
  },
})
